import styles from './Table.module.scss'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { headCells } from './table.headings'
import { useTranslation } from 'react-i18next'
import { dateSort } from './utils'
import { colors } from '@features/laborRecords/utils'
import onRequestActionMenuClick from './actionMenu/onRequestActionMenuClick'
import DropDownMenu from '@/components/DropdownMenu/DropdownMenu'
import { getCurrentLanguage } from '@/i18next'
import { laborRecordsActions, laborRecordsSelectors, laborRecordsThunks } from '@/entity'
import { useDispatch, useSelector } from 'react-redux'
import { SolutionEmployer } from '@features/contracts/correctionRequests/components/Solution/SolutionEmployer'
import { useDigitalSign } from '@/shared'
import { LoadingBlocker } from '@/components/Loader'
import { View } from '@features/laborRecords/actions'
export const Table = ({ tableData }) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()
	const dispatch = useDispatch()
	const { onSign, successPayload, onClearPayload } = useDigitalSign()
	const isLoading = useSelector(laborRecordsSelectors.isRequestLoading)
	const isSuccess = useSelector(laborRecordsSelectors.isRequestSuccess)
	const isRefresh = useSelector(laborRecordsSelectors.isAdjustmentRefresh)
	const [requestAdjustmentId, setRequestAdjustmentId] = useState(null)
	const [actionMenuItems, setActionMenuItems] = useState([])
	const isLoadingAdjustment = useSelector(laborRecordsSelectors.isCancelAdjustmentXmlLoading)
	const isSuccessAdjustment = useSelector(laborRecordsSelectors.isCancelAdjustmentXmlSuccess)
	const xml = useSelector(laborRecordsSelectors.cancelAdjustmentXml)
	const requestDetail = useSelector(laborRecordsSelectors.requestDetail)
	const [actions, setActions] = useState({
		view: false,
		confirm: false,
		reject: false,
	})
	useEffect(() => {
		if (isRefresh) {
			dispatch(laborRecordsThunks.getRequestsAdjustmentDetailJur(requestAdjustmentId))
		}
	}, [isRefresh])

	useEffect(() => {
		if (requestDetail?.requestsAdjustmentId != null) {
			tableData.splice(
				tableData.findIndex((item) => item.requestsAdjustmentId === requestAdjustmentId),
				1,
				requestDetail
			)
		}
	}, [requestDetail])
	const tableHeader = useMemo(
		() => (
			<>
				{headCells.map((head, index) => (
					<th key={index + 'thead-th'}>{t(head.label)}</th>
				))}
			</>
		),
		[t]
	)

	const getRequest = useCallback((id) => dispatch(laborRecordsThunks.getRequestsAdjustmentDetailJur(id)), [dispatch])
	const onToggleAction = (action, value, row) => {
		setActions((prevState) => {
			if (action === 'view' && value) {
				setRequestAdjustmentId(row.requestsAdjustmentId)
				getRequest(row.requestsAdjustmentId)
			} else if ((action === 'confirm' || action === 'reject') && value) {
				setRequestAdjustmentId(row.requestsAdjustmentId)
			}
			return { ...prevState, [action]: value }
		})
	}
	const onToggleContractAction = (action, value) => {
		setActions((prevState) => {
			if ((action === 'confirm' || action === 'reject') && value) {
				setRequestAdjustmentId(requestAdjustmentId)
			}
			return { ...prevState, [action]: value }
		})
	}
	const fastView = (row) => {
		onToggleAction('view', true, row)
	}
	const onActionMenuChoose = (mode, row) => {
		onToggleAction(mode, true, row)
	}
	const getTableRow = useCallback(
		(row, index) => (
			<tr key={index} onClick={() => fastView(row)}>
				<td>{row.requestsAdjustmentDate}</td>
				<td>{lang === 'rus' ? row.requestType.nameRu : row.requestType.nameKz}</td>
				<td>{row.iin}</td>
				<td>{row.employeeFio}</td>
				<td>
					<span style={{ color: colors[row.requestStatus?.code] }}>
						{lang === 'rus' ? row.requestStatus.nameRu : row.requestStatus.nameKz}
					</span>
				</td>
				<td onClick={(e) => onRequestActionMenuClick(row, e, setActionMenuItems, t)}>
					<DropDownMenu
						title={t('select_pls')}
						items={actionMenuItems}
						onItemClick={(mode) => onActionMenuChoose(mode, row)}
					/>
				</td>
			</tr>
		),
		[actionMenuItems, lang, onActionMenuChoose, t]
	)
	const tableBody = useMemo(
		() => dateSort(tableData)?.map((row, index) => getTableRow(row, index)),
		[tableData, getTableRow]
	)

	const handleProcess = (data) => {
		!isLoadingAdjustment && dispatch(laborRecordsThunks.getConfirmRequestAdjustmentXml({ ...data }))
	}

	const closeProcess = () => {
		dispatch(laborRecordsActions.setCancelAdjustmentXml(null))
		dispatch(laborRecordsActions.toggleCancelAdjustmentXmlSuccess(false))
		if (actions.confirm || actions.reject) {
			setActions({ view: actions.view, confirm: false, reject: false })
		} else {
			setActions({ view: false, confirm: false, reject: false })
		}
		onClearPayload()
	}
	const onClear = () => {
		onClearPayload()
		dispatch(laborRecordsActions.setCancelAdjustmentXml(null))
	}
	useEffect(() => {
		xml && onSign(xml)
		successPayload && !xml && closeProcess()
	}, [xml]) /** подписание xml */

	useEffect(() => {
		/** очистка и выход при удачной операции */
		isSuccessAdjustment && closeProcess()
		return () => closeProcess()
	}, [isSuccessAdjustment])

	useEffect(() => {
		if (successPayload) {
			dispatch(laborRecordsThunks.sendConfirmRequestAdjustment({ signedXml: successPayload }))
		}
	}, [successPayload])

	return (
		<>
			{actions.confirm || actions.reject ? (
				<SolutionEmployer
					onSubmit={handleProcess}
					handleCancel={closeProcess}
					action={actions}
					requestAdjustmentId={requestAdjustmentId}
				></SolutionEmployer>
			) : null}
			{(isLoading || isLoadingAdjustment) && <LoadingBlocker />}
			<table className={styles.table}>
				<thead>
					<tr>{tableHeader}</tr>
				</thead>
				<tbody>{tableBody}</tbody>
			</table>
			{actions.view && !isLoading && isSuccess ? (
				<View onToggleAction={onToggleAction} onToggleContractAction={onToggleContractAction}></View>
			) : null}
		</>
	)
}
